var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpretorPercentageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2565_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06734 14.6338L0.183594 13.75L13.9336 0L14.8173 0.88375L1.06734 14.6338ZM5.62547 2.94188C5.62547 1.56313 4.50422 0.441875 3.12547 0.441875C1.74672 0.441875 0.625469 1.56313 0.625469 2.94188C0.625469 4.32063 1.74672 5.44188 3.12547 5.44188C4.50422 5.44188 5.62547 4.32063 5.62547 2.94188ZM4.37547 2.94188C4.37547 3.63125 3.81484 4.19188 3.12547 4.19188C2.43609 4.19188 1.87547 3.63125 1.87547 2.94188C1.87547 2.2525 2.43609 1.69188 3.12547 1.69188C3.81484 1.69188 4.37547 2.2525 4.37547 2.94188ZM14.3755 11.6919C14.3755 10.3131 13.2542 9.19188 11.8755 9.19188C10.4967 9.19188 9.37547 10.3131 9.37547 11.6919C9.37547 13.0706 10.4967 14.1919 11.8755 14.1919C13.2542 14.1919 14.3755 13.0706 14.3755 11.6919ZM13.1255 11.6919C13.1255 12.3813 12.5648 12.9419 11.8755 12.9419C11.1861 12.9419 10.6255 12.3813 10.6255 11.6919C10.6255 11.0025 11.1861 10.4419 11.8755 10.4419C12.5648 10.4419 13.1255 11.0025 13.1255 11.6919Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2565_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpretorPercentageIcon);
export default __webpack_public_path__ + "static/media/opretor_percentage_icon.06dc208d2a8a7af4572686606ef9b385.svg";
export { ForwardRef as ReactComponent };